import React from "react";
import {
  View,
  StyleSheet,
  TouchableOpacity,
  TouchableOpacityProps,
} from "react-native";
import {
  UIActivityIndicator,
  UIActivityIndicatorProps,
} from "react-native-indicators";

import Icon from "components/Icon";
import Text from "components/Text";
import ImgIcon from "components/imgIcon";

import tinyColor from "tinycolor2";
import { colors, sizes } from "assets/constants";

const Button = (props: ButtonT & TouchableOpacityProps) => {
  const {
    direction = "rtl",
    title,
    icon,
    imgIcon,

    width = "100%",
    height = 45,
    square,
    circle,
    radius = sizes.radius.lg,
    contentSeparator,
    bgColor = colors.theme,
    style,
    zIndex,
    mb,
    mt,
    mr,
    ml,
    mv,
    mh,
    bottom,
    top,
    left,
    right,
    absolute,
    bordered,

    renderContent,
    loading,
    loadingProps,
    outline,
  } = props;

  const backgroundColor = outline ? colors.transparent : bgColor;

  const buttonBg = tinyColor(bgColor);
  const contentColor = title?.color
    ? title?.color
    : outline
    ? bgColor
    : buttonBg.isDark()
    ? colors.white
    : colors.text.normal;

  const styles = StyleSheet.create({
    container: {
      width: circle || square || width,
      height: circle || square || height,
      position: absolute ? "absolute" : "relative",
      top,
      bottom,
      left,
      right,
      marginVertical: mv,
      marginHorizontal: mh,
      marginLeft: ml,
      marginRight: mr,
      marginTop: mt,
      marginBottom: mb,
      overflow: "hidden",
      zIndex,
      borderRadius: circle ? 100 : radius,
      ...(outline ? { borderWidth: 1, borderColor: bgColor } : {}),
      ...(bordered
        ? { borderWidth: bordered.width, borderColor: bordered.color }
        : {}),
      backgroundColor,
      ...style,
    },

    contentContainer: {
      flex: 1,
      alignItems: "center",
      justifyContent: "center",
      flexDirection: direction === "rtl" ? "row-reverse" : "row",
    },

    content: {
      flex: 1,
      width: "100%",
      height: "100%",
      alignSelf: "center",
      justifyContent: "center",
    },

    loadingContainer: {
      flex: 1,
      width: "100%",
      height: "100%",
      position: "absolute",
      alignItems: "center",
      justifyContent: "center",
    },
  });

  return (
    <TouchableOpacity
      disabled={loading || props.disabled}
      activeOpacity={loading ? 1 : 0.85}
      {...(props as TouchableOpacityProps)}
      style={styles.container}
    >
      {renderContent ? (
        renderContent(bgColor, contentColor)
      ) : (
        <>
          {!loading && (
            <View style={styles.contentContainer}>
              {icon && <Icon size={18} color={contentColor} {...icon} />}
              {imgIcon && <ImgIcon color={contentColor} {...imgIcon} />}
              {((title && icon) || (title && imgIcon)) && (
                <View style={{ width: contentSeparator ?? sizes.space }} />
              )}
              {title && (
                <Text
                  align="center"
                  size={"lg"}
                  weight={"medium"}
                  color={contentColor}
                  style={{ bottom: 1 }}
                  {...title}
                >
                  {title?.value}
                </Text>
              )}
            </View>
          )}
          {loading && (
            <View style={styles.contentContainer}>
              <UIActivityIndicator
                color={contentColor}
                size={25}
                {...loadingProps}
              />
            </View>
          )}
        </>
      )}
    </TouchableOpacity>
  );
};

export default Button;
